import React from "react";
import {
  Skeleton,
  SkeletonStatsCard,
  SkeletonCard,
  SkeletonButton,
} from "../Skeleton";
import { cn } from "../../lib/utils";

interface DashboardSkeletonProps {
  statsCount?: number;
  showQuickActions?: boolean;
  showSections?: boolean;
  className?: string;
}

export const DashboardSkeleton: React.FC<DashboardSkeletonProps> = ({
  statsCount = 6,
  showQuickActions = true,
  showSections = true,
  className,
}) => {
  return (
    <div className={cn("min-h-screen py-4", className)}>
      <div className="mx-auto">
        {/* Header */}
        <div className="mb-6 sm:mb-8">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
            <div className="flex-1">
              <Skeleton
                variant="text"
                width="60%"
                height={40}
                className="mb-2"
              />
              <Skeleton variant="text" width="40%" height={20} />
            </div>
            <div className="flex items-center space-x-3">
              <SkeletonButton width={200} height={44} />
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
          {Array.from({ length: statsCount }).map((_, i) => (
            <SkeletonStatsCard
              key={i}
              className={cn(
                i < statsCount - 1
                  ? "bg-linear-to-br from-tiber-500 to-tiber-600"
                  : "bg-white border border-tiber-600"
              )}
            />
          ))}
        </div>

        {/* Quick Actions */}
        {showQuickActions && (
          <div className="bg-linear-to-r from-emerald-500 to-green-600 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8 shadow-lg animate-pulse">
            <Skeleton
              variant="text"
              width="30%"
              height={28}
              className="mb-4 bg-white/30"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonButton
                  key={i}
                  width="100%"
                  height={48}
                  className="bg-white/30"
                />
              ))}
            </div>
          </div>
        )}

        {/* Sections Grid */}
        {showSections && (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
              <SkeletonCard />
              <SkeletonCard />
            </div>

            <div className="grid grid-cols-1 gap-4 mb-6">
              <SkeletonCard />
              <SkeletonCard />
            </div>

            <div className="grid grid-cols-1 gap-6 mb-6 sm:mb-8">
              <SkeletonCard />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
